import { useCallback, useEffect } from 'react'
import ad from 'api/axios/foka/ad'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { fail } from 'features/toast/Toast'
import { fetchCampaign } from '../../campaign/campaignSlice'
import { fetchAdGroup } from '../../group/adGroupSlice'

const useKeywordGenerable = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { campaignId, adGroupId } = useParams()
  const { accountId: adAccountId } = useParams()
  const checkGenerable = useCallback(async () => {
    const { error: campaignError, payload: campaignPayload } = await dispatch(
      fetchCampaign(campaignId)
    )
    if (campaignError) {
      const { errorCode, errorMessage } = campaignPayload
      return Promise.reject({
        message:
          errorCode === 409
            ? '삭제된 캠페인 입니다.'
            : errorMessage || '알 수 없는 에러가 발생했습니다.',
      })
    }
    const { error: adGroupError, payload: adGroupPayload } = await dispatch(
      fetchAdGroup(adGroupId)
    )
    if (adGroupError) {
      const { errorCode, errorMessage } = adGroupPayload
      return Promise.reject({
        message:
          errorCode === 409 || errorCode === 104007
            ? '삭제된 캠페인 입니다.'
            : errorMessage || '알 수 없는 에러가 발생했습니다.',
      })
    }
    const {
      data: { generable },
    } = await ad.getKeywordsGenerable(adGroupId)
    if (generable === false) {
      return Promise.reject({
        message:
          '등록 가능한 키워드 개수를 초과하였습니다.\n미사용 키워드를 삭제 후 다시시도하세요.',
      })
    }
  }, [dispatch, campaignId, adGroupId])
  useEffect(() => {
    ;(async () => {
      try {
        await checkGenerable()
      } catch (e) {
        const { message } = e
        fail(message)
        history.push(`/${adAccountId}/dashboard`)
      }
    })()
  }, [adAccountId, history, checkGenerable])
}

export default useKeywordGenerable
